<div class="d-flex ms-4">
	<div class="d-flex flex-column flex-fill">
		<div class="d-flex justify-content-between">
			<div>Pay mode enabled</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
					[disabled]="true"
					[(ngModel)]="onDevice.features.pay"
				></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<div>Order mode enabled</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
					[disabled]="true"
					[(ngModel)]="onDevice.features.order"
				></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<div>Server Pay Mode</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
					[disabled]="!onDevice.features.pay"
					[(ngModel)]="onDevice.features.onServerPay"
				></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<div>LoyaltyTab Enabled</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
					[(ngModel)]="onDevice.features.loyaltyTab"
				></p-inputSwitch>
			</div>
		</div>
	</div>
</div>
